import React from 'react';
import NotFoundContainer from './styles';

function NotFound() {
  return (
    <NotFoundContainer>
      <h1>
        Desculpe! Página não encontrada :(
      </h1>
    </NotFoundContainer>
  );
}

export default NotFound;
